import './CreateProjectModalLayout.scss';
import classNames from 'classnames';
import { ReactElement, ReactNode } from 'react';
import { S_Modal } from '../../../../../design/modals/modal/S_Modal';

interface CreateProjectModalLayout {
  isOpen: boolean;
  className?: string;
  headerText: ReactNode;
  buttons: ReactNode;
  children: ReactNode;
  toggle: () => void;
}

export const CreateProjectModalLayout = ({ children, className, isOpen, headerText, buttons, toggle }: CreateProjectModalLayout): ReactElement => (
  <S_Modal
    headerText={headerText}
    buttons={buttons}
    isOpen={isOpen}
    toggle={toggle}
    className={classNames('create-project-modal', className)}
  >
    {children}
  </S_Modal>
);
